import moment from 'moment/moment';
const axios = require('axios');

(() => {
  const calendarTable = '.day-camping-calendar-table';
  const prevWeekButton = '.dc-move-to-prev-week';
  const nextWeekButton = '.dc-move-to-next-week';
  const calendarInfo = '.day-camping-calendar-info';
  const adultNumPulldown = '.day-camping-adult-num'
  const kidsNumPulldown = '.day-camping-kids-num';
  const babyNumPulldown = '.day-camping-baby-num';
  const reserveDateSelect = '#day-camping-reserve-date-select';
  const dayCampingGrass = '.dc-grass';
  const nextButton = '.dc-rental-and-consumable-item-page-button';
  const futureDate = moment().add(6, 'months').toDate();
  const DATE_FORMAT = 'YYYY年MM月DD日（dd）';
  const showDisabledBtn = '.dc-show-disabled-button';
  const showActiveBtn = '.dc-show-active-button';
  var firstDateValue = {};
  var lastDateValue = {};
  var firstDateWeakMap = new WeakMap;
  var lastDateWeakMap = new WeakMap;

  const init = () => {
    if (location.href.indexOf('customer/day_camping/day_camping_reservation') < 1 ) {
      return
    }
    if ($('.dc-step-1').length < 1) {
      return
    }
    $('.dc-max-two-sections').hide();
    $('.dc-max-three-sections').hide();
    $('.dc-max-four-sections').hide();
    $('.dc-max-five-sections').hide();
    $(calendarTable).hide();
    $(prevWeekButton).hide();
    $(nextWeekButton).hide();
    $(calendarInfo).hide();
    $(nextButton).prop('disabled', true);
    $(showDisabledBtn).show();
    $(showActiveBtn).hide();
    $('.dc_after_info_open_calendar').removeClass('active');
    showCampingSubscriptionWord();

    $('body')
      .on('change', adultNumPulldown, showInitWeekReservationStatus)
      .on('change', kidsNumPulldown, showInitWeekReservationStatus)
      .on('change', babyNumPulldown, showInitWeekReservationStatus)
      .on('change', adultNumPulldown, limitNumberOfSections)
      .on('change', kidsNumPulldown, limitNumberOfSections)
      .on('change', babyNumPulldown, limitNumberOfSections)
      .on('change', reserveDateSelect, showInitWeekReservationStatus)
      .on('click', nextWeekButton, showNextWeekReservationStatus)
      .on('click', prevWeekButton, showPrevWeekReservationStatus)
      .on('change', adultNumPulldown, showCampingSubscriptionWord)
      .on('change', kidsNumPulldown, showCampingSubscriptionWord)
      .on('click', dayCampingGrass, setGrassValue);
    showInitWeekReservationStatus();

    $(reserveDateSelect).on('apply.daterangepicker', (ev, picker) => {
      $(reserveDateSelect).val(picker.startDate.format(DATE_FORMAT))
    })
  }

  const setGrassValue = e => {
    e.preventDefault();
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date')
    $(calendarTable).find('td').removeClass('reservation-check-mark');
    const $element = $(e.currentTarget);
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date');
    var date = $element.data('date');
    document.getElementById('day-camping-reserve-date').value = date;
    document.getElementById('barbecue-area-id').value = 1;
    $(nextButton).prop('disabled', false);
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
    document.getElementById('day-camping-reserve-date-select').value = moment(date).format(DATE_FORMAT);
  }

  const showInitWeekReservationStatus = (e) => {
    if (e) {
      e.preventDefault();
    }
    if ($(adultNumPulldown).val() < 1) {
      $(calendarTable).hide();
      $(prevWeekButton).hide();
      $(nextWeekButton).hide();
      $(calendarInfo).hide();
      $(nextButton).prop('disabled', true);
      $(showDisabledBtn).show();
      $(showActiveBtn).hide();
      $('.dc_before_info_open_calendar').show();
      $('.dc_after_info_open_calendar').removeClass('active');
      return false
    }
    let reserveDateSelectString = $(reserveDateSelect).val();
    reserveDateSelectString = reserveDateSelectString.replace(/\(|\)|（|）|日|月|火|水|木|金|土|年|月|日/g, '');
    const reserveDateSelectObj = moment(reserveDateSelectString).toDate();

    const currentDateObj = getEarliestDate();

    if (reserveDateSelectObj.getTime() > currentDateObj.getTime()) {
      var nextDateString = reserveDateSelectString;
    } else {
      var nextDateString = getStringFromDate(currentDateObj);
    }

    $(calendarTable).show();
    if (reserveDateSelectObj.getTime() == currentDateObj.getTime()) {
      $(prevWeekButton).addClass('disabled');
    } else {
      $(prevWeekButton).removeClass('disabled').prop('disabled', false);
    }
    if (reserveDateSelectObj.getTime() < currentDateObj.getTime()) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
    }
    $(prevWeekButton).show();
    $(nextWeekButton).show();
    $('.dc_before_info_open_calendar').hide();
    $('.dc_after_info_open_calendar').addClass('active');
    removePrependedCalendarInfo();
    fetchReservationStatus(nextDateString);
    $(calendarInfo).show();

    const selectedDate = $('#day-camping-reserve-date').val();
    const selectedArea = $('#barbecue-area-id').val();

    if (selectedDate && selectedArea) {
      $(nextButton).prop('disabled', false);
      $(showDisabledBtn).hide();
      $(showActiveBtn).show();
    }
    false
  }

  const showNextWeekReservationStatus = e => {
    e.preventDefault();
    $(prevWeekButton).prop('disabled', false).removeClass('disabled');
    const lastDateString = lastDateWeakMap.get(lastDateValue);
    var lastDate = new Date(lastDateString);
    lastDate.setDate(lastDate.getDate() + 1);
    const nextDateString = getStringFromDate(lastDate);
    removePrependedCalendarInfo();
    fetchReservationStatus(nextDateString);
  }

  const showPrevWeekReservationStatus = e => {
    e.preventDefault();
    
    const currentDate = getEarliestDate();

    const firstDateString = firstDateWeakMap.get(firstDateValue);
    var firstDate = new Date(firstDateString);
    firstDate.setDate(firstDate.getDate() - 5);
    if (currentDate.getTime() > firstDate.getTime()) {
      firstDate = currentDate;
    }
    if (moment(firstDate).format('YYYY/MM/DD') == moment(currentDate).format('YYYY/MM/DD')) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
      $(showDisabledBtn).show();
      $(showActiveBtn).hide();
    }

    const prevWeekfirstDateString = getStringFromDate(firstDate);
    removePrependedCalendarInfo();
    fetchReservationStatus(prevWeekfirstDateString);
  }

  const getEarliestDate = () => {
    if (moment().hour() >= 12) {
      return moment().add(1, 'days').toDate();
    } else {
      return moment().toDate();
    }
  }

  const fetchReservationStatus = date => {
    return axios.get(process.env.JS_BASE_URL + 'api/v1/day_camping_calendars', {
      params: {
        date: date
      }
    })
    .then(response => {
      removePrependedCalendarInfo();
      const grassAreaReservations = response.data[0];

      $('#dc-calendar-month').prepend('<td colspan="2"></td>');
      $('#dc-calendar-date').prepend('<th class="area" colspan="2">エリア</th>');
      if (grassAreaReservations) {
        grassAreaReservations.forEach(reservation => {
          let selectedDate = $('#day-camping-reserve-date').val();
          const selectedArea = $('#barbecue-area-id').val();
          if (selectedArea != 1) {
            selectedDate = ''
          }
          const date = new Date(reservation.date);
          const reservationDate = date.getDate();
          const reservationMonth = date.getMonth() + 1;
          const jaWDay = getJapaneseWDay(date);
          const wDay = date.getDay();
          const subscriptionTotalPeople = check_subscription_total_num(reservation);
          const taxRate = $('#data-tax').data('tax-rate');
          if (subscriptionTotalPeople != null) {
            var charge;
            charge = (reservation.charge - 100) * (1 + taxRate);
          } else {
            charge = reservation.charge * (1 + taxRate);
          }

          let addTdStyle = '';
          let addAStyle = '';
          let addSelectClass = '';
          if (selectedDate && moment(reservation.date).format('YYYYMMDD') == moment(selectedDate).format('YYYYMMDD')) {
            addTdStyle = 'background-color: #527342;';
            addAStyle = 'background-color: #fff;';
            addSelectClass = 'select-date reservation-check-mark';
          }

          $('#dc-calendar-month').append(`<td>${reservationMonth}月</td>`);
          if (wDay === 0) {
            $('#dc-calendar-date').append(`<td class='barbecue-calender-date sunday-reservation'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          } else if (wDay === 6) {
            $('#dc-calendar-date').append(`<td class='barbecue-calender-date saturday-reservation'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          } else {
            $('#dc-calendar-date').append(`<td class='barbecue-calender-date'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          }

          if (futureDate.getTime() > date.getTime()) {
            if (reservation.non_business_date === true) {
              $('#calendar-grass-reservation-num').append(`<td class='unavailable-reservation day-camping-reservation-status'>-</td>`);
            } else {
              if (reservation.reservation_rate >= 100) {
                $('#calendar-grass-reservation-num').append(`<td class='unavailable-reservation times-mark day-camping-reservation-status'></td>`);
              } else if (reservation.reservation_rate >= 80) {
                if (subscriptionTotalPeople === 1) {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}"><span class='click-underline triangle-mark'></span></a></a></td>`);
                } else if (subscriptionTotalPeople > 1) {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}">${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></a></td>`);
                } else {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}">${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></a></td>`);
                }
              } else {
                if (subscriptionTotalPeople === 1) {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}"><span class='click-underline circle-mark'></span></a></a></td>`);
                } else if (subscriptionTotalPeople > 1) {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}">${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></a></td>`);
                } else {
                  $('#calendar-grass-reservation-num').append(`<td class="${addSelectClass} day-camping-reservation-status" style="${addTdStyle}"><a class='dc-grass' data-date=${reservation.date} href='' style="${addAStyle}">${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></a></td>`);
                }
              }
            }
          }
        })
        var firstDate = grassAreaReservations[0].date;
        var lastDate = grassAreaReservations[4].date;
        $('#calendar-grass-reservation-num').prepend(`<td rowspan="2" colspan="2"><a href='' class='text-link site-c-modal-button day-camping-calendar-font' data-target='#campingAreaModal' data-toggle='modal'>あなたらしくサイト</a></td>`);
      }

      firstDateWeakMap.set(firstDateValue, firstDate);
      lastDateWeakMap.set(lastDateValue, lastDate);
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const removePrependedCalendarInfo = () => {
    $('#dc-calendar-month').empty();
    $('#dc-calendar-date').empty();
    $('#calendar-grass-reservation-num').empty();
  }

  const getStringFromDate = lastDate => {
    const year_str = lastDate.getFullYear();
    var month_str = 1 + lastDate.getMonth();
    var day_str = lastDate.getDate();
    month_str = ('0' + month_str).slice(-2);
    day_str = ('0' + day_str).slice(-2);
    let nextDateString = 'YYYY-MM-DD'
    nextDateString = nextDateString.replace(/YYYY/g, year_str);
    nextDateString = nextDateString.replace(/MM/g, month_str);
    nextDateString = nextDateString.replace(/DD/g, day_str);
    return nextDateString;
  }

  const getJapaneseWDay = date => {
    var weekChars = ['日', '月', '火', '水', '木', '金', '土'];
    let wDay = date.getDay();
    return weekChars[wDay];
  }

  const limitNumberOfSections = () => {
    const totalNum = parseInt($(adultNumPulldown).val()) + parseInt($(kidsNumPulldown).val()) + parseInt($(babyNumPulldown).val());
    var maxSectionNum;
    switch (true) {
      case totalNum > 16:
        $('.dc-max-one-section').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-two-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-three-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-four-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-five-sections').show().children('.dc_max_sections').prop('disabled', false);
        break;
      case totalNum > 12:
        $('.dc-max-one-section').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-two-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-three-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-four-sections').show().children('.dc_max_sections').prop('disabled', false);
        $('.dc-max-five-sections').hide().children('.dc_max_sections').prop('disabled', true);
        break;
      case totalNum > 8:
        $('.dc-max-one-section').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-two-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-three-sections').show().children('.dc_max_sections').prop('disabled', false);
        $('.dc-max-four-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-five-sections').hide().children('.dc_max_sections').prop('disabled', true);
        break;
      case totalNum > 4:
        $('.dc-max-one-section').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-two-sections').show().children('.dc_max_sections').prop('disabled', false);
        $('.dc-max-three-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-four-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-five-sections').hide().children('.dc_max_sections').prop('disabled', true);
        break;
      case totalNum <= 4:
        $('.dc-max-one-section').show().children('.dc_max_sections').prop('disabled', false);
        $('.dc-max-two-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-three-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-four-sections').hide().children('.dc_max_sections').prop('disabled', true);
        $('.dc-max-five-sections').hide().children('.dc_max_sections').prop('disabled', true);
        break;
    }
  }

  const showCampingSubscriptionWord = e => {
    const totalNum = parseInt($(adultNumPulldown).val()) + parseInt($(kidsNumPulldown).val());
    if (totalNum > 1) {
      $('.info_one_dc_subscriber').hide();
      $('.info_more_than_two_including_dc_subscriber').show();
    } else {
      $('.info_one_dc_subscriber').show();
      $('.info_more_than_two_including_dc_subscriber').hide();
    }
  }

  const check_subscription_total_num = (reservation) => {
    let totalNum = parseInt($(adultNumPulldown).val()) + parseInt($(kidsNumPulldown).val());

    if (reservation.camping_subscriber == true) {
      return totalNum;
    }
  }
  $(init);
})();

